export const NotEqual = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 10.0006C14 10.2771 13.7765 10.5006 13.5 10.5006H7.413L5.9555 13.7076C5.872 13.8916 5.6905 14.0006 5.5 14.0006C5.431 14.0006 5.361 13.9866 5.2935 13.9556C5.042 13.8411 4.931 13.5451 5.0455 13.2936L6.315 10.5006H2.5C2.2235 10.5006 2 10.2771 2 10.0006C2 9.72409 2.2235 9.50059 2.5 9.50059H6.769L8.1325 6.50059H2.5C2.2235 6.50059 2 6.27709 2 6.00059C2 5.72409 2.2235 5.50059 2.5 5.50059H8.587L10.0445 2.29359C10.1585 2.04309 10.4525 1.92959 10.7065 2.04559C10.958 2.16009 11.069 2.45609 10.9545 2.70759L9.685 5.50059H13.4995C13.776 5.50059 13.9995 5.72409 13.9995 6.00059C13.9995 6.27709 13.776 6.50059 13.4995 6.50059H9.2305L7.867 9.50059H13.4995C13.776 9.50059 14 9.72409 14 10.0006Z"
        fill="#888399"
      />
    </svg>
  );
};
